import axios from "axios";

import { GetMigrationScriptParams, MigrationScriptFileDetail, MigrationScriptRequest, MigrationScriptResponse } from "./migrate.schema";

export async function callAddMigrationScript(data: MigrationScriptRequest) {
    const formData = new FormData();
    formData.append("company", data.company);
    formData.append("group", data.group);
    formData.append("remark", data.remark);
    formData.append("detail", data.detail);
    formData.append("created_by", data.created_by);
    formData.append("tk", data.tk);
    formData.append("type", data.type);

    data.files.forEach(file => {
        formData.append("files", file);
    });

    return axios.post<string>('v1/insert-migration-scriptGroup', formData);
}

export async function callRetrieveMigrationScript(params: GetMigrationScriptParams) {

    return axios.get<MigrationScriptResponse[]>('v1/get-migration-scriptGroup', {
        params: params
    });
}

export async function callRetrieveMigrationScriptDetailContent(filePath: string) {
    return axios.get<string>('v1/get-migration-script-detail', {
        params: { filePath }
    });
}